import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';

const CurrentIssuerMainContact = forwardRef((props, ref) => {
  const {onDataFetch, reportId, reportType} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [issuerContact, setIssuerContact] = useState([]); //Existing issuer contact for main contact role in Issue Contact Assoc table


  useEffect(() => {
    if (reportId){
      getIssueContactById(reportId);
    }
   
  }, [reportId]);


  useImperativeHandle(ref, () => {
      return {
        getIssueContactById
      };
  }, [])
  

  //I need to make this function generic so that I can use for RFS too 
  // since both reports will use this component
  const getIssueContactById = (selectedId) => {
    const opr = reportType === "RFS" ? "getIssueContactByFinalSaleId" : "getIssueContactByProposeDebtId";
    var obj = {
      msgId: null,
      sysId: null,
      opr: opr,
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issueId": selectedId
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssuerContact(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  
  const columnsIssuerContact = [{
    dataField: 'contactLastName',
    text: 'Contact Last Name',
    sort: true,
  },{
    dataField: 'contactFirstName',
    text: 'Contact First Name',
    sort: true,
  },{
    dataField: 'roleCodeDescription',
    text: 'Contact Role Description',
    sort: true,
  }
  ];


  return (
    <div>
      <DataGrid
        title="Current Issuer Main Contact:"
        dataSource={issuerContact}
        sortField='contactId'
        showQuickSearch={false}
        emptyDataMessage='No data available to display'
      >
        {columnsIssuerContact.map((column, i) => {
          return (
            <Column
              key={i}
              field={column.dataField}
              header={column.text}
              body={column.formatter}
              hidden={column.hidden}
            />)
        })
        }
      </DataGrid>
    </div>

  )
});

export default CurrentIssuerMainContact;